//Reset data
export const RESET = "CATEGORY_UPDATE_RESET"

export const SET_IS_UPDATED = "CATEGORY_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "CATEGORY_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "CATEGORY_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CATEGORY_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CATEGORY_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CATEGORY_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CATEGORY_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CATEGORY_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CATEGORY_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CATEGORY_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CATEGORY_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "CATEGORY_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "CATEGORY_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CATEGORY_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CATEGORY_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CATEGORY_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "CATEGORY_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "CATEGORY_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CATEGORY_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CATEGORY_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CATEGORY_UPDATE_SET_MODAL_TYPE"